import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import FAQQuestionsPage from '@/components/pages/faq/questions';

const ProtectedFAQQuestionsPage = withAuthenticationRequired(FAQQuestionsPage, {
  onRedirecting: () => <Loading />,
});

export const Route = createFileRoute('/faq/questions')({
  head: () => ({ meta: [{ title: `FAQ | ${activeConfig.branding.appName}` }] }),
  component: ProtectedFAQQuestionsPage,
});
